import dayjs from 'dayjs';

import { today } from '@constants/utils.constant';
import type { QualitySurveyToken } from '@models/survey.model';

export function qualitySurveyTokenDecoder(token: string): QualitySurveyToken {
  const decodedToken = atob(token);

  const parsedToken: Omit<QualitySurveyToken, 'triggerDate'> =
    JSON.parse(decodedToken);
  console.log(
    'encodedToken',
    btoa(
      JSON.stringify({
        exp: 1779946196,
        id: '019e0784-7f49-7cd7-a559-bc521bb2e3e8',
        parentId: '019cbe75-7b46-7077-9147-c058b235a9b7',
        parentStatus: 'lost',
        type: 'intervention',
        providerName: 'Nu-Isoleren.be',
        source: 'connect',
      }),
    ),
  );

  const todayPlus3 = dayjs(today).add(3, 'day');
  const expDate = dayjs.unix(parsedToken.exp);
  const triggerDate = todayPlus3.isAfter(expDate)
    ? today
    : todayPlus3.format('YYYY-MM-DD');

  return {
    exp: parsedToken.exp,
    id: parsedToken.id,
    parentId: parsedToken.parentId,
    parentStatus: parsedToken.parentStatus,
    providerName: parsedToken.providerName,
    source: parsedToken.source,
    triggerDate,
    type: parsedToken.type,
  };
}
